import { Injectable } from '@angular/core';
import { Product } from '../../interfaces';
import { LLPType } from '../../enums';

@Injectable({
    providedIn: 'root'
})
export class LlpBuyService {
    product: Product;
    selectedPlan: LLPType;
    constructor() {}

    setProduct(product: Product) {
        this.product = product;
    }

    setPlan(plan: LLPType) {
        this.selectedPlan = plan;
    }
}
